import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  DefaultTheme,
} from "react-native-paper";
import { blackColor } from "../../common/colors";
import { StyleSheet, SafeAreaView } from "react-native";
import PageContainer from "../PageContainer";
import routes from "../../routing/routes";
import { connect } from "react-redux";

const Page = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const [expanded, setExpanded] = React.useState({});

  React.useEffect(() => {
    props.callToData();
  }, []);

  const handlePress = (i, value) => {
    const newExpanded = {
      ...expanded,
      [i]: value,
    };
    setExpanded(newExpanded);
  };
  return (
    <PageContainer
      {...props}
      isBackIcon={true}
      noBackground={true}
      isSettingsIconSelected={props.user ? true : false}
      backRoute={props.user ? routes.Settings : routes.RegistrationForm}
    >
      <SafeAreaView styles={{ flex: 1 }}>
        <Text style={styles.text}>
          {props.pageData && props.pageData.title}
        </Text>
        {props.pageData &&
          props.pageData.content.map((paragraf, i) => {
            const titleParagraf = `§ ${i + 1}`;

            const isNested = typeof paragraf === "object";
            return isNested ? (
              <React.Fragment key={`page-${i}`}>
                <Text style={styles.title}>
                  {titleParagraf} - {paragraf.paragrafTitle}
                </Text>
                {paragraf.paragrafContent.map((subParagraf, j) => (
                  <Text key={`page-text-${i}-${j}`} style={styles.subtitle}>
                    {j + 1}.{subParagraf}
                  </Text>
                ))}
              </React.Fragment>
            ) : (
              <>
                <Text style={styles.title}>{titleParagraf}</Text>
                <Text style={styles.subtitle}>{paragraf}</Text>
              </>
            );
          })}
      </SafeAreaView>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  return { user };
};

export default connect(mapStateToProps)(Page);

const styles = StyleSheet.create({
  text: {
    paddingTop: 30,
    fontSize: 20,
    letterSpacing: 1,
    color: blackColor,
    padding: 8,
    textAlign: "center",
  },
  title: {
    padding: 8,
    textAlign: "center",
    fontWeight: "bold",
  },
  subtitle: {
    padding: 8,
    textAlign: "left",
  },
});
